/* eslint-disable camelcase */
import map from "lodash/fp/map";
import constants from "../../core/constants";

const deductionPriceType = [
  { name: "percentage", display: "Percentage (%)" },
  { name: "fixed", display: "Fixed" },
];

class DeductionplansPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Supply Deduction Plan",
      state: "deductionplan",
      name: "deductionPlan",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Currency", name: "currency", isSortable: true },
      {
        title: "Deduction for short delay",
        name: "delay_deduction",
        isSortable: true,
      },
    ];

    this.addOptions = {
      title: "Add New Supply Deduction plan",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Supply Deduction plan name",
          type: "name",
          isText: true,
          isRequired: true,
        },
        {
          name: "description",
          title: "Supply Deduction plan description",
          type: "name",
          isText: true,
          isRequired: true,
        },
        { resource: "City", name: "city", title: "City", isResource: true },
        {
          name: "ride_late_deduction",
          title: "Ride Late Deduction",
          isObjectsList: true,
          items: [],
        },
      ],
      deduction_rate_type: deductionPriceType,
    };
  }

  justify(data) {
    const format = (item) => {
      item.delay_deduction /= constants.currencyBy;
      return item;
    };
    return map(format)(data);
  }
}

export default DeductionplansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/deductionplans/deductionplans.transforms.js